import React from 'react';

import './createPosition.scss'
import '../Homepage/Homepage.scss'

import { useLocation } from 'react-router-dom';

import {SystemIcon} from '@workday/canvas-kit-react/icon';
import {setupIcon, chartIcon} from '@workday/canvas-system-icons-web';

import ContentTable from './components/contentTable/contentTable';
import ContentTableTwo from './components/contentTable2/contentTable2';
import { supervisoryOrganizations, findOption } from '../../data/organizations';

const CreatePosition = (props) => {
    const { search } = useLocation();
    const parameters = new URLSearchParams(search);
    const supervisoryOrganization = findOption(supervisoryOrganizations, parameters.get('supervisoryOrganization'))

    return (
        <div className='createPosition'>
            <div className='bannerText'>
                <h2>Create Position</h2>
                <div className='icons'>
                    <SystemIcon
                        className='setupIcon'
                        icon={setupIcon}
                        fill={"#e8ebed"}
                    />
                    <SystemIcon
                        className='chartIcon'
                        icon={chartIcon}
                        fill={"#e8ebed"}
                    />
                </div>
            </div>
            <div className='content'>
                <ContentTable supervisoryOrganization={supervisoryOrganization}/>
            </div>
            <div className='content2'>
                <ContentTableTwo/>
            </div>
            <div className='buttons'>
                <a href='/?process=createPositionFin'><button className='ok'>Submit</button></a>
                <a href='/'><button className='cancel'>Save for later</button></a>
                <a href='/'><button className='cancel'>Cancel</button></a>
            </div>
        </div>
    )
}

export default CreatePosition;
